//热门推荐
<template>
  <div class="hot2">
    <div class="title">
      推荐视频
    </div>
    <a v-for="(item,index) in list" :key="index" class="box1" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank">
      <div class="imgBox">
        <img :src="item.CONTENT_PHOTO_SMALL" alt="">
      </div>
      <p :class="index==list.length-1?'titles1':'titles'">
        {{ item.CONTENT_TITLE }}
      </p>
      <div class="vdoIMG" />
    </a>
  </div>
</template>
<script>
export default {
  props: ['list'],
  methods: {
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .hot2{
        background-color: #fff;
        padding-bottom: 10px;
        overflow: hidden;
        padding-top: 10px;
        margin-top: 10px;
        .title{
            height: 20px;
            line-height: 20px;
            border-left: 2px solid #ed4040;
            padding-left: 10px;
            font-size: 16px;
            margin-left: 20px;
        }
        .box1{
            padding: 5px 20px;
          position: relative;
          display: inline-block;
            .imgBox{
                width: 260px;
                height: 150px;
                img{
                    width: 260px;
                    height: 150px;
                    cursor: pointer;
                }
            }
            .titles{
                margin-top: 20px;
                padding-bottom: 10px;
                border-bottom: 1px solid #e5e5e5;
                cursor: pointer;
              width: 250px;
              text-align: left;
            }
            .titles1{
              width: 250px;
                margin-top: 20px;
                cursor: pointer;
              text-align: left;
            }
        }
    }
    .vdoIMG{
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 3px solid rgba(249,245,246,.5);
      position: absolute;
      top: 55px;
      left: 120px;
      cursor: pointer;
    }
    .vdoIMG::after{
      content: '';
      display: block;
      position: absolute;
      top: 13px;
      left: 17px;
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-bottom:  12px solid transparent;
      border-left:20px solid rgba(247,247,247,.5);
    }
</style>
